import { Sheet } from './Sheet.js';
import { Button } from './Button.js';
import { useI18n } from '../i18n/index.js';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  body?: string;
  /** 되돌릴 수 없는 동작이면 빨갛게 */
  destructive?: boolean;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * 되돌릴 수 없는 동작을 한 번 더 묻는다.
 *
 * `window.confirm`을 쓰지 않는 이유: 브라우저 기본 대화상자는 번역되지 않고
 * (OS 언어를 따른다), 모바일에서 생김새가 제각각이며, 무엇을 지우는지
 * 맥락을 보여줄 수 없다.
 *
 * **남용하지 않는다.** 모든 동작에 확인을 붙이면 사용자는 읽지 않고 누르게 되고,
 * 그러면 정작 위험한 순간에도 그냥 넘긴다. 복구할 수 없는 것에만 쓴다.
 */
export function ConfirmDialog({
  open,
  title,
  body,
  destructive = false,
  confirmLabel,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { t } = useI18n();

  return (
    <Sheet
      open={open}
      onClose={onCancel}
      title={title}
      {...(body === undefined ? {} : { lead: body })}
    >
      <div style={{ display: 'flex', gap: 'var(--s2)', marginTop: 'var(--s3)' }}>
        <Button variant={destructive ? 'danger' : 'solid'} fullWidth onClick={onConfirm}>
          {confirmLabel ?? t('common.confirm')}
        </Button>
        <Button variant="quiet" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
      </div>
    </Sheet>
  );
}
